import { METHOD } from './method'

export const API_SPECIAL_GIFT = {
    LIST: {
        api: '/v1/dashboard-admin/general-setting/special-gift/list',
        method: METHOD.POST,
    },
    DELETE: {
        api: '/v1/dashboard-admin/general-setting/special-gift',
        method: METHOD.DELETE,
    },
    DETAIL: {
        api: '/v1/dashboard-admin/general-setting/special-gift',
        method: METHOD.GET,
    },
    GIFT_LIST: {
        api: '/v1/dashboard-admin/general-setting/special-gift/gift',
        method: METHOD.GET,
    },
    URL_BANNER_IMAGES: {
        api: '/v1/dashboard-admin/general-setting/special-gift/storage-url/attachment',
        method: METHOD.POST,
    },
    CREATE: {
        api: '/v1/dashboard-admin/general-setting/special-gift',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/general-setting/special-gift',
        method: METHOD.PUT,
    },
}
